// ===============================================================================
// ForgotPassword.js - Password Reset Request Page
// ===============================================================================

import React, { useState } from "react";
import { authAPI } from "./api";
import "./Login.css";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await authAPI.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      console.error("Forgot password error:", err);
      // Always show success to prevent email enumeration
      setSuccess(true);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="logo">
            <span className="logo-icon">💰</span>
            <h1>SplitMon</h1>
          </div>

          <div className="email-sent-icon">📧</div>
          
          <h2>Check Your Email</h2>
          
          <p className="check-email-text">
            If an account exists for <strong>{email}</strong>, we've sent a password reset link.
            <br /><br />
            Please check your inbox and spam folder. The link will expire in 1 hour.
          </p>

          <div className="back-link">
            <a href="/login">← Back to Login</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="logo">
          <span className="logo-icon">💰</span>
          <h1>SplitMon</h1>
        </div>

        <h2>Forgot Password?</h2>
        <p className="subtitle">
          Enter your email address and we'll send you a link to reset your password.
        </p>

        {error && <div className="message error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            required
            autoComplete="email"
          />

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <div className="back-link">
          <a href="/login">← Back to Login</a>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;

